import React, { useEffect, useState } from 'react';
import { LoaderIcon } from 'lucide-react';
const PROCESSING_MESSAGES = ['Validating fields...', 'Checking required columns...', 'Comparing records against internal database...', 'Identifying missing loans...', 'Detecting duplicates...', 'Generating reports...'];
export function ProcessingStatusIndicator() {
  const [messageIndex, setMessageIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex(prev => (prev + 1) % PROCESSING_MESSAGES.length);
    }, 600);
    return () => clearInterval(interval);
  }, []);
  return <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-10" role="status" aria-live="polite" data-id="element-104">
      <div className="flex flex-col items-center gap-5" data-id="element-105">
        <div className="relative" data-id="element-106">
          <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center" data-id="element-107">
            <LoaderIcon className="w-8 h-8 text-blue-600 animate-spin" aria-hidden="true" data-id="element-108" />
          </div>
          <div className="absolute inset-0 w-16 h-16 rounded-full border-4 border-blue-200 border-t-blue-600 animate-spin" style={{
          animationDuration: '1.5s'
        }} data-id="element-109" />
        </div>
        <div className="text-center" data-id="element-110">
          <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-111">
            Processing Snapshot
          </h3>
          <p className="text-sm text-gray-600 transition-opacity duration-300" key={messageIndex} data-id="element-112">
            {PROCESSING_MESSAGES[messageIndex]}
          </p>
        </div>
        <div className="w-64 h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-113">
          <div className="h-full bg-blue-600 rounded-full animate-pulse" style={{
          width: `${(messageIndex + 1) / PROCESSING_MESSAGES.length * 100}%`,
          transition: 'width 0.5s ease'
        }} data-id="element-114" />
        </div>
      </div>
    </div>;
}